import React from 'react';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ButtonDesigned from '../../Buttons/ButtonDesigned';

interface Props {
  onAction: () => void;
  title: string;
  description: string | React.ReactNode;
  actionText?: string;
  onCancel: () => void;
}

export const ConfirmDelete: React.FC<Props> = ({ onAction, onCancel, title, description, actionText = 'Remove' }) => (
  <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center z-50">
    <div className="flex  flex-col gap-4 py-3 px-6 items-center bg-white border-t-4 border-red w-[24rem] ">
      <div className="text-red ">
        <ErrorOutlineOutlinedIcon style={{ width: 40, height: 40 }} />
      </div>
      <p className="font-medium text-lg">{title}</p>
      <p className="text-sm text-secondary_text text-center">{description}</p>
      <div className="flex gap-3">
        <ButtonDesigned onButtonClick={onCancel} style="outline">
          Cancel
        </ButtonDesigned>
        <ButtonDesigned onButtonClick={onAction} style="primary">
          {actionText}
        </ButtonDesigned>
      </div>
    </div>
  </div>
);
